import { lazy } from "react";
import tickets from '../tickets/routes';
import clients from '../clients/routes';
import contacts from '../contacts/routes';
import settings from '../settings/routes';
import agencies from '../agencies/routes';
import dealers from '../dealers/routes';
import dashboard from '../dashboard/routes';

const EntryPoint = lazy(() => import(/* webpackChunkName: "home" */ './components/EntryPoint'));

export const innerRoutes = [tickets, clients, contacts, agencies, dealers, dashboard, settings];

const home = {
    path: '/',
    Component: EntryPoint,
    exact: false,
    innerRoutes: [...innerRoutes]
};

export default home;
